import * as type from "../../types/API/stockUpdate";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const stockUpdateReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.STOCK_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case type.STOCK_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.STOCK_UPDATE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};